import React from 'react';
import Loader from './Loader';

const LoadingOverlay = () => {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const backdropStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    backdropFilter: 'blur(1px)'
  };

  const contentStyle = {
    position: 'relative',
    zIndex: 1
  };

  return (
    <div style={overlayStyle}>
      <div style={backdropStyle}></div>
      <div style={contentStyle}>
        <Loader />
      </div>
    </div>
  );
};

export default LoadingOverlay;
